import { ajax as request } from '@blade/common';
/** ==============================@Description: 底图接口============================== */
export const getMap = () => request({
    url: '/api/task-management/api/v1/map',
    method: 'GET'
});
